export const storageUnitsNearMe = {
	menuName: "Storage Units Near Me",
	sections: [
		{
			title: "Amenities",
			defaultExpanded: false,
			links: [
				{
					text: "24 Hour Storage Units Near You",
					href: "/storage-units-near-me/24-hour-storage-units/"
				},
				{
					text: "Climate Controlled Storage Units Near You",
					href: "/storage-units-near-me/climate-controlled-storage-units/"
				},
				{
					text: "Drive Up Storage Units Near You",
					href: "/storage-units-near-me/drive-up-storage-units/"
				},
				{
					text: "Storage Units With Free Truck Rental Near You",
					href: "/storage-units-near-me/storage-units-with-free-truck-rental/"
				}
			]
		},
		{
			title: "Unit Sizes",
			defaultExpanded: false,
			links: [
				{
					text: "5x5 Storage Units Near You",
					href: "/storage-units-near-me/5x5-storage-units/"
				},
				{
					text: "5x10 Storage Units Near You",
					href: "/storage-units-near-me/5x10-storage-units/"
				},
				{
					text: "5x15 Storage Units Near You",
					href: "/storage-units-near-me/5x15-storage-units/"
				},
				{
					text: "10x10 Storage Units Near You",
					href: "/storage-units-near-me/10x10-storage-units/"
				},
				{
					text: "10x15 Storage Units Near You",
					href: "/storage-units-near-me/10x15-storage-units/"
				},
				{
					text: "10x20 Storage Units Near You",
					href: "/storage-units-near-me/10x20-storage-units/"
				},
				{
					text: "10x25 Storage Units Near You",
					href: "/storage-units-near-me/10x25-storage-units/"
				},
				{
					text: "10x30 Storage Units Near You",
					href: "/storage-units-near-me/10x30-storage-units/"
				}
			]
		}
	],
	// TODO: uncomment in deals branch to enable, shouldn't be released with NMPs
	// footerLink: {
	// 	text: "Storage Unit Deals Near You",
	// 	href: "/storage-units-near-me/deals"
	// }
};

export const storage101 = {
	menuName: "Storage 101",
	links: [
		{
			text: "Size Guide",
			href: "/self-storage-size-guide/"
		},
		{
			text: "Indoor vs. Outdoor Storage",
			href: "/indoor-vs-outdoor/"
		},
		{
			text: "Storage Security",
			href: "/storage-security/"
		},
		{
			text: "Storage Insurance",
			href: "/storage-insurance/"
		}
	]
};

export const storageTypes = {
	menuName: "Storage Types",
	links: [
		{
			text: "Size Guide",
			href: "/self-storage-size-guide/"
		},
		{
			text: "Self Storage",
			href: "/storage-solutions/what-are-storage-units/"
		},
		{
			text: "Vehicle Storage",
			submenu: [
				{
					text: "Car Storage",
					href: "/storage-solutions/car-storage-units/"
				},
				{
					text: "RV Storage",
					href: "/storage-solutions/rv-storage-units/"
				},
				{
					text: "Boat Storage",
					href: "/storage-solutions/boat-storage-units/"
				},
				{
					text: "Motorcycle Storage",
					href: "/storage-solutions/motorcycle-storage-units/"
				}
			]
		},
		{
			text: "Climate Controlled Storage",
			href: "/storage-solutions/climate-controlled-storage-units/"
		},
		{
			text: "College Storage",
			href: "/storage-solutions/college-storage-units/"
		},
		{
			text: "Business Storage",
			href: "/storage-solutions/business-storage-units/"
		}
	]
};
